module.exports = __webpack_public_path__ + "static/IMG-7-4379f0c883dba44ad3bf42c7bbff158f.jpg";